import { React,useEffect, useState, useMemo } from "react";
import PropTypes from 'prop-types';
import '../customChannelPreview.css';
import { useTranslation } from "react-i18next";
import {locale} from "../i18n.js";
import { startOfDay, isBefore } from "date-fns";

export function isBeforeToday(dateLastMessage, today) {
    return isBefore(startOfDay(dateLastMessage), startOfDay(today));
}

const CustomChannelPreview = ({ channel, unreadActivated, selectedChannelUrl, getChannelNickname, userId }) => {
    const isSelected = selectedChannelUrl === channel._url;
    const dateLastMessage = channel.lastMessage ? new Date(channel.lastMessage.createdAt) : null;
    const [nickname, setNickname] = useState('');
    const [bookingId, setBookingId] = useState(null);
    const { t } = useTranslation();

    useEffect(() => {
        async function getBookingId() {
            if (channel.cachedMetaData?.booking_id) {
                setBookingId(channel.cachedMetaData.booking_id);
                return;
            }

            const metadata = await channel.getMetaData(['booking_id']);

            if (metadata.booking_id) {
                setBookingId(metadata.booking_id);
            }
        }

        getChannelNickname(channel, userId, setNickname);
        getBookingId();
    }, [channel, userId, getChannelNickname]);

    const formattedDate = useMemo(() => {
        if (!dateLastMessage) {
            return '';
        }

        const today = new Date();
        const localeString = locale.replace("_", "-");

        if (isBeforeToday(dateLastMessage, today)) {
            return new Intl.DateTimeFormat(localeString, {
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: false
            }).format(dateLastMessage);
        }

        return new Intl.DateTimeFormat(localeString, {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        }).format(dateLastMessage);
    }, [dateLastMessage]);

    return (
        <div
            className={isSelected ? "menuItemSelected" : "menuItem"}
            style={{display: unreadActivated && !channel.unreadMessageCount ? "none" : "block"}}
        >
            <h4>
                {nickname || ""}

                <span className="bookingId">
                    {bookingId && (
                        <a
                            href={`${process.env.REACT_APP_INBOX_BASE_URL}/booking/view/${bookingId}`}
                            target="_blank"
                            rel="noreferrer"
                            className="bookingLink"
                        >
                            {bookingId}
                        </a>
                    )}
                </span>

                <span className="bookingDate">{formattedDate}</span>
            </h4>

            {channel.unreadMessageCount > 0 && (
                <span className="unreadMessageCount">{channel.unreadMessageCount}</span>
            )}

            <p className="lastMessage">{channel.lastMessage?.message || t('no_messages_yet')}</p>
        </div>
    );
};

CustomChannelPreview.propTypes = {
    channel: PropTypes.shape({
        _url: PropTypes.string,
        lastMessage: PropTypes.shape({
            createdAt: PropTypes.number,
            message: PropTypes.string,
        }),
        cachedMetaData: PropTypes.shape({
            booking_id: PropTypes.string,
        }),
        unreadMessageCount: PropTypes.number,
        getMetaData: PropTypes.func,
    }).isRequired,
    unreadActivated: PropTypes.bool.isRequired,
    selectedChannelUrl: PropTypes.string,
    getChannelNickname: PropTypes.func.isRequired,
    userId: PropTypes.string.isRequired,
};

export default CustomChannelPreview;